<div id="wait" *ngIf="isLoading == 1">
  <mat-spinner></mat-spinner>
</div>

<div class="row mt-3 score-align-row">
  <div class="col-auto">
    <p class="mtitle mb-0">Select Score to view trends (Multi-select for making comparison)</p>
  </div>
</div>
<div class="row mt-1">
  <div class="col-md-12">

    <label class="radioOpt"><input class="square-radio" type="checkbox" id="heald" [(ngModel)]="selectedVitals['hlth']"
        (change)="onVitalToggle('hlth')"> Heald</label>
    <label class="radioOpt"><input class="square-radio" type="checkbox" id="sleep" [(ngModel)]="selectedVitals['slp']"
        (change)="onVitalToggle('slp')" checked> Sleep</label>
    <label class="radioOpt"><input class="square-radio" type="checkbox" id="recovery"
        [(ngModel)]="selectedVitals['reco']" (change)="onVitalToggle('reco')"> Readiness</label>
    <label class="radioOpt"><input class="square-radio" type="checkbox" id="glucose" [(ngModel)]="selectedVitals['glu']"
        (change)="onVitalToggle('glu')"> Glucose</label>
    <label class="radioOpt"><input class="square-radio" type="checkbox" id="nutrition"
        [(ngModel)]="selectedVitals['nut']" (change)="onVitalToggle('nut')"> Nutrition</label>
    <label class="radioOpt"><input class="square-radio" type="checkbox" id="activity"
        [(ngModel)]="selectedVitals['acty']" (change)="onVitalToggle('acty')"> Activity</label>
    <label class="radioOpt"><input class="square-radio" type="checkbox" id="engagement"
        [(ngModel)]="selectedVitals['eng']" (change)="onVitalToggle('eng')"> Engagement</label>
  </div>
</div>

<div class="score-chart-container" style="width: 90%; position: relative; min-height: 300px;" *ngIf="showChart">
  <highcharts-chart #chart [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag"
    [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngular"
    style="width: 100%; height: 100%; display: block;"></highcharts-chart>
  <div *ngIf="noDataFound"
    style="position: absolute; top: 50%; left: 0; width: 100%; text-align: center; transform: translateY(-50%); pointer-events: none;">
    <h6 style="color: gray;">{{ emptyMessage }}</h6>
  </div>
</div>